import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { DateRange } from '@mui/lab/DateRangePicker';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from "axios";
import * as CSS from "csstype";
import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { API_URL, AUTHORITY_LIST } from "../../Const";
import ConfirmDialog from "../Dialog";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';

// フォームの型
interface UserCreateFormInput {
  password: string,
  password_re: string
}

// バリデーションルール
const schema = yup.object({
  password: yup
    .string()
    .required('必須項目です') // 必須チェック
    .min(8, '8文字以上入力してください') // 最小文字数8文字チェック
    .max(30, '30文字以下で入力してください') // 最大文字数30文字チェック
    // 英字が含まれているかチェック
    .matches(
      /[a-zA-Z]/,
      '英字を含めてください'
    )
    // 数字含まれているかチェック
    .matches(
      /[0-9]/,
      '数字を含めてください'
    )
    // 半角文字チェック
    .matches(
      /^[\x20-\x7e]*$/,
      '半角文字で入力してください。'
    ),
    // .matches(
    //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&].*$/,
    //   'パスワードが弱いです(半角、全角、記号を組み合わせてください)'
    // ),
  password_re: yup
    .string()
    .required('必須項目です') // 必須チェック
    .min(8, '8文字以上入力してください') // 最小文字数8文字チェック
    .max(30, '30文字以下で入力してください') // 最大文字数30文字チェック
    // 英字が含まれているかチェック
    .matches(
      /[a-zA-Z]/,
      '英字を含めてください'
    )
    // 数字含まれているかチェック
    .matches(
      /[0-9]/,
      '数字を含めてください'
    )
    // 半角文字チェック
    .matches(
      /^[\x20-\x7e]*$/,
      '半角文字で入力してください'
    )
    // .matches(
    //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&].*$/,
    //   'パスワードが弱いです(半角、全角、記号を組み合わせてください)'
    // )

    .oneOf([yup.ref('password'), null], '入力したパスワードが一致しません'),
})

// 権限
const currencies = AUTHORITY_LIST

const useStyles = makeStyles(() =>
  createStyles({
    datePicker: {
      width: '25ch',
    },
  })
);

const msgStyle: CSS.Properties = {
  fontSize: "14px",
  fontWeight: "600",
  color: "#3f3f3f",
  margin: "5px",
  textAlign: "left"
}


const UserEditPassword: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()
  const history = useHistory();
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')

  const { state } = useLocation();
  // const s_user_id = (state as any)?.id;
  const s_company_id = (state as any)?.company_id;
  const s_user_name = (state as any)?.user_name;
  const s_user_name_kana = (state as any)?.user_name_kana;
  const s_user_id = (state as any)?.user_id;
  const s_authority_code = (state as any)?.authority_code;
  const s_remarks = (state as any)?.remarks;

  /*送信パラメータ*/
  const [user_name, setUserName] = useState();
  const [user_name_kana, setUserNameKana] = useState();
  const [user_id, setUserId] = useState();
  const [password, setPassword] = useState();
  const [password_re, setPasswordRe] = useState();
  const [authority_code, setAuthorityCode] = useState('');
  const [remarks, setRemarks] = useState();
  /* 送信パラメータ値設定 */
  const changeUserName = (e: any) => {
    setUserName(e.target.value);
  }
  const changeUserNameKana = (e: any) => {
    setUserNameKana(e.target.value);
  }
  const changeUserId = (e: any) => {
    setUserId(e.target.value);
  }
  const changePassword = (e: any) => {
    setPassword(e.target.value);
  }
  const changePasswordRe = (e: any) => {
    setPasswordRe(e.target.value);
  }
  const changeRemarks = (e: any) => {
    setRemarks(e.target.value);
  }

  //バリデーション設定
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserCreateFormInput>({
    resolver: yupResolver(schema),
  })

  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
  const classes = useStyles();
  const [selectedDate, setSelectedData] = useState<MaterialUiPickersDate>(null);
  // const [currency, setCurrency] = React.useState('');
  const [currency, setCurrency] = useState('');
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const handleChange = (e: any) => {
    setAuthorityCode(e.target.value);
    setCurrency(e.target.value);
  };
  interface State {
    amount: string;
    password: string;
    weight: string;
    weightRange: string;
    showPassword: boolean;
  }

  const [values, setValues] = React.useState<State>({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });

  const handleChange2 =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
    };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  // 追加ボタン押下時の処理
  const onSubmit: SubmitHandler<UserCreateFormInput> = (data) => {
    handleClickOpenEdit()
  }

  const [showPassword, setShowPassword] = useState(false);

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理(キャンセル)*/
  const [openCancel, setOpenCancel] = React.useState(false);
  const handleClickOpenCancel = () => {
    setOpenCancel(true);
  };
  const gotoEdit = () => {
    // 編集画面に戻る
    history.push({ pathname: "/UserEdit", state: { user_id: s_user_id, company_id: s_company_id, user_name: s_user_name, user_name_kana: s_user_name_kana, authority_code: s_authority_code, remarks: s_remarks } });
  };
  const setConfirmOpenCancel = (check: any) => {
    setLoading(false);
    setOpenCancel(check)
  };
  /*ダイアログ処理(キャンセル)*/

  /*ダイアログ処理(追加)*/
  const [openEdit, setOpenEdit] = React.useState(false);
  const handleClickOpenEdit = () => {
    setOpenEdit(true);
  };
  const changePass = () => {
    if (!loading) {
      setLoading(true);
    }
    openLoading()
    axios.post(API_URL.USER_UPDATE,
      {
        "company_id": s_company_id,
        "dealer_info_id": s_company_id,
        "user_id": s_user_id,
        "password": password,
        "now_password": ""
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        closeLoading()
        // 編集に戻る
        history.push({ pathname: "/UserEdit", state: { user_id: s_user_id, company_id: s_company_id, user_name: s_user_name, user_name_kana: s_user_name_kana, authority_code: s_authority_code, remarks: s_remarks } });

      })
      .catch(error => {
        console.log('error:', error)
        setLoading(false);
      })
      .finally(() => {
        closeLoading()
      })
  };
  const setConfirmOpenEdit = (check: any) => {
    setOpenEdit(check)
  };
  /*ダイアログ処理(追加)*/


  // 表示処理
  return (

    <GenericTemplate title="パスワード変更">

      <div>
        <ConfirmDialog
          title="パスワードを変更しますか？"
          open={openEdit}
          setOpen={setConfirmOpenEdit}
          onConfirm={changePass}
          loading={loading}
        >
          更新後詳細画面へ戻ります
        </ConfirmDialog>
      </div>

      <div>
        <ConfirmDialog
          title="編集画面に戻りますか？"
          open={openCancel}
          setOpen={setConfirmOpenCancel}
          onConfirm={gotoEdit}
          loading={loading}
        >
          入力中のデータは破棄されます
        </ConfirmDialog>
      </div>


      <Stack spacing={3} margin={2}></Stack>

    <p style={msgStyle} >※半角英数字を必ず1つ含めてください(大文字記号可)<br />
      ※8文字以上30文字以内
        {/* ※以下の記号が利用可能<br />
        ! " # $ % & ' ( ) * + , - . / : ; {'<'} = {'>'} ? @ [ \ ] ^ _ ` {'{'} | {'}'} ~ */}
      </p>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">新パスワード*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <div>
              <TextField
                required
                // label="パスワード"
                type="string"
                {...register('password')}
                error={'password' in errors}
                helperText={errors.password?.message}
                onChange={changePassword}
              />
            </div>
          </Grid>
        </Grid>

        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">新パスワード(確認用)*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <div>
              <TextField
                required
                // label="パスワード"
                type="string"
                {...register('password_re')}
                error={'password_re' in errors}
                helperText={errors.password_re?.message}
                onChange={changePasswordRe}
              />
            </div>
          </Grid>
        </Grid>
      </Stack>


      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}></Stack>

      <Stack spacing={0} margin={0}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={10}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              onClick={handleSubmit(onSubmit)}
            >
              変更
            </Button>
          </Grid>
          <Grid item={true} sm={5} md={6} xs={10}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              // component={Link}
              onClick={handleClickOpenCancel}
            // to="/Userlist"
            >
              キャンセル
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </GenericTemplate>
  );
};

export default UserEditPassword;